export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'MyStorageXへようこそ',
  'login.description': 'MyStorageXは、安全で便利なファイル保存と管理サービスを提供するクラウドストレージアシスタントです。いつでもどこでもファイルにアクセスできます。',
  'login.email.placeholder': 'メールアドレスまたはユーザー名',
  'login.password.placeholder': 'パスワード',
  'login.button': 'ログイン',
  'login.loading': 'ログイン中...',
  'login.divider': 'または',
  'login.signup': 'アカウントをお持ちでない方',
  'login.signup.link': '新規登録',
  'login.error.default': 'ログインに失敗しました。後でもう一度お試しください',
  'login.success': 'ログインしました',
  'login.forgotPassword': 'パスワードをお忘れですか？',
  'login.forgotPassword.link': 'こちらでリセット',
  'login.verificationCode.placeholder': '認証コードを入力してください',
  'login.verificationCode.send': '認証コードを取得',
  'login.verificationCode.sending': '送信中...',
  'login.verificationCode.retry': '{seconds}秒後に再試行',
  'login.verificationCode.success': '認証コードが送信されました',
  'login.verificationCode.error': '認証コードの送信に失敗しました',
  'login.verificationCode.required': '認証コードを入力してください',
  'login.verificationCode.invalid': '認証コードの形式が正しくありません',
  'signup.page.title': '新規登録 - MyStorageX',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'MyStorageXへようこそ',
  'signup.description': 'アカウントを作成してクラウドストレージの旅を始めましょう',
  'signup.username.placeholder': 'ユーザー名を入力',
  'signup.email.placeholder': 'メールアドレスを入力',
  'signup.password.placeholder': 'パスワードを入力',
  'signup.confirmPassword.placeholder': 'パスワードを確認',
  'signup.button': '登録',
  'signup.loading': '登録中...',
  'signup.login': 'すでにアカウントをお持ちの方',
  'signup.login.link': 'ログイン',
  'signup.error.passwordMismatch': 'パスワードが一致しません',
  'signup.error.default': '登録に失敗しました。後でもう一度お試しください',
  'signup.success': '登録が完了しました',
  'signup.username.rule.length': 'ユーザー名は4〜10文字である必要があります',
  'signup.username.rule.format': '文字、数字、アンダースコア、ハイフンのみ使用可能です',
  'signup.password.rule.length': 'パスワードは6〜20文字である必要があります',
  'signup.password.rule.lowercase': '小文字を含める必要があります',
  'signup.password.rule.uppercase': '大文字を含める必要があります',
  'signup.password.rule.number': '数字を含める必要があります',
  'signup.password.rule.special': '特殊文字を含める必要があります',
  'signup.verificationCode.placeholder': '認証コードを入力',
  'signup.verificationCode.send': '認証コードを取得',
  'signup.verificationCode.sending': '送信中...',
  'signup.verificationCode.retry': '{seconds}秒後に再試行',
  'signup.verificationCode.success': '認証コードを送信しました',
  'signup.verificationCode.error': '認証コードの送信に失敗しました',
  'signup.error.emailRequired': 'メールアドレスを入力してください',
  'signup.announcement': '本日は登録機能はメンテナンス中です！',
  'resetPassword.page.title': 'パスワードのリセット - MyStorageX',
  'resetPassword.page.description': 'MyStorageXアカウントのパスワードをリセット',
  'resetPassword.title': 'パスワードのリセット',
  'resetPassword.email.placeholder': 'メールアドレスを入力',
  'resetPassword.code.placeholder': '認証コードを入力',
  'resetPassword.password.placeholder': '新しいパスワードを入力',
  'resetPassword.button': 'パスワードをリセット',
  'resetPassword.button.loading': 'リセット中...',
  'resetPassword.backToLogin': 'ログインに戻る',
  'resetPassword.sendCode': '認証コードを取得',
  'resetPassword.sendCode.sending': '送信中...',
  'resetPassword.sendCode.retry': '{seconds}秒後に再試行',
  'resetPassword.error.emailRequired': 'メールアドレスを入力してください',
  'resetPassword.error.codeRequired': '認証コードを入力してください',
  'resetPassword.error.passwordRequired': '新しいパスワードを入力してください',
  'resetPassword.error.passwordLength': 'パスワードは6-20文字で入力してください',
  'resetPassword.error.codeLength': '認証コードは6桁で入力してください',
  'resetPassword.success.codeSent': '認証コードをメールに送信しました',
  'resetPassword.success.reset': 'パスワードのリセットが完了しました',
  'resetPassword.error.sendFailed': '認証コードの送信に失敗しました。後でもう一度お試しください',
  'resetPassword.error.resetFailed': 'パスワードのリセットに失敗しました。後でもう一度お試しください',
  'sidebar.allFiles': 'すべてのファイル',
  'sidebar.starred': 'お気に入り',
  'sidebar.folders': 'フォルダ',
  'sidebar.trash': 'ゴミ箱',
  'sidebar.decrypt': '復号化ツール',
  'sidebar.feedback': 'フィードバック',
  'sidebar.about': '概要',
  'sidebar.productLog': '更新履歴',
  'filelist.column.name': '名前',
  'filelist.column.size': 'サイズ',
  'filelist.column.updateTime': '更新日時',
  'filelist.column.recycletime': '削除日時',
  'filelist.column.actions': '操作',
  'filelist.total': '合計 {total} 件',
  'filelist.action.upload': 'アップロード',
  'filelist.action.newFolder': '新規フォルダ',
  'filelist.action.refresh': '更新',
  'filelist.action.search': 'ファイル検索',
  'filelist.action.batchDownload': 'ダウンロード',
  'filelist.action.batchDelete': '削除',
  'filelist.action.download': 'ダウンロード',
  'filelist.action.preview': 'プレビュー',
  'filelist.action.rename': '名前変更',
  'filelist.selected': '{count} 件選択',
  'page.cloudDrive.title': 'マイクラウドドライブ',
  'page.cloudDrive.description': 'MyStorageX クラウドドライブ - 安全にファイルを保存・管理',
  'modal.fileUpload.title': 'ファイルアップロード',
  'modal.fileUpload.dragText': 'ここにファイルをドラッグ、またはクリックしてアップロード',
  'modal.fileUpload.start': 'アップロード開始',
  'modal.fileUpload.cancel': 'キャンセル',
  'modal.fileUpload.clear': 'リストをクリア',
  'modal.fileUpload.encrypt': '選択したファイルを暗号化',
  'modal.fileUpload.addMore': '追加',
  'modal.fileUpload.remove': '削除',
  'modal.fileUpload.error.noSelection': '削除するファイルを選択してください',
  'modal.fileUpload.error.noEncryption': '暗号化するファイルを選択してください',
  'modal.fileUpload.error.noClear': 'クリアするファイルがありません',
  'modal.fileUpload.error.noStart': 'アップロードするファイルがありません',
  'modal.fileUpload.error.noCancel': 'キャンセルするアップロードがありません',
  'modal.fileUpload.error.fileSize': 'ファイルサイズが制限を超えています',
  'modal.fileUpload.error.fileType': '対応していないファイル形式です',
  'modal.fileUpload.error.maxCount': 'ファイル数が制限を超えています',
  'modal.fileUpload.duplicate.title': 'ファイルが既に存在します',
  'modal.fileUpload.duplicate.skip': 'スキップ',
  'modal.fileUpload.duplicate.replace': '置き換え',
  'modal.fileUpload.duplicate.rename': '名前変更',
  'modal.fileUpload.status.pending': '待機中',
  'modal.fileUpload.status.uploading': 'アップロード中',
  'modal.fileUpload.status.success': '完了',
  'modal.fileUpload.status.error': 'エラー',
  'modal.fileUpload.status.cancelled': 'キャンセル',
  'modal.fileUpload.status.duplicated': '重複',
  'modal.fileUpload.table.filename': 'ファイル名',
  'modal.fileUpload.table.size': 'サイズ',
  'modal.fileUpload.table.status': '状態',
  'modal.fileUpload.table.progress': '進捗',
  'modal.fileUpload.table.actions': '操作',
  'modal.fileUpload.speed': 'アップロード速度',
  'modal.fileUpload.remainingTime': '残り時間',
  'modal.fileUpload.total.progress': '全体の進捗',
  'modal.fileUpload.error.message': 'アップロード失敗: {message}',
  'modal.fileUpload.confirm.clear': 'アップロードリストをクリアしますか？',
  'modal.fileUpload.confirm.cancel': 'アップロードをキャンセルしますか？',
  'modal.fileUpload.clear.mobile': 'クリア',
  'modal.fileUpload.encrypt.mobile': '暗号化',
  'modal.fileUpload.addMore.mobile': '追加',
  'productLog.title': '更新履歴',
  'security.features.title': 'セキュリティ機能',
  'security.features.localDecryption.title': 'ローカル復号化',
  'security.features.localDecryption.description': 'すべての復号化操作はブラウザ内で実行され、ファイル内容とパスワードがデバイスから外部に送信されることはありません',
  'security.features.militaryEncryption.title': '軍事級暗号化',
  'security.features.militaryEncryption.description': 'AES-256-CBC暗号化アルゴリズムを使用。既知のすべての攻撃に耐えうる最も安全な対称暗号化規格です',
  'security.features.privacyProtection.title': 'プライバシー保護',
  'security.features.privacyProtection.description': '厳格なプライバシー保護メカニズムにより、復号化パスワードは保存されず、ファイル内容も記録されません',
  'security.features.smartDecryption.title': 'スマートチャンク復号化',
  'security.features.smartDecryption.description': 'スマートチャンク復号化技術により、復号化速度を大幅に向上させながらメモリ使用量を削減します',
  'security.features.learnMore': '詳細を見る',
  'security.features.modal.title': 'セキュリティ機能の詳細',
  'security.features.modal.close': '閉じる',
  'decrypt.security.modal.title': 'セキュリティ通知',
  'decrypt.security.modal.description': 'すべての復号化操作はローカルで実行され、パスワードやファイル内容がサーバーにアップロードされることはありません',
  'decrypt.security.modal.vip.title': 'VIPユーザーの特典：',
  'decrypt.security.modal.vip.feature1': 'どんなサイズのファイルも復号化可能',
  'decrypt.security.modal.vip.feature2': 'スマートチャンク復号化で効率アップ',
  'decrypt.security.modal.vip.feature3': '大容量ファイルの一括復号化に対応',
  'decrypt.security.modal.free.title': '重要：復号化にはファイルサイズの約3倍のブラウザメモリが必要です。',
  'decrypt.security.modal.free.feature1': '無料ユーザーは1ファイル4GBまで',
  'decrypt.security.modal.free.feature2': 'VIPにアップグレードで容量制限解除',
  'decrypt.security.modal.free.feature3': 'ブラウザがクラッシュする場合はVIPのチャンク復号化機能の利用を検討してください',
  'security.diagram.plaintext.block1': '平文ブロック1',
  'security.diagram.plaintext.block2': '平文ブロック2',
  'security.diagram.ciphertext.block1': '暗号文ブロック1',
  'security.diagram.ciphertext.block2': '暗号文ブロック2',
  'security.diagram.key': '鍵',
  'security.diagram.aes.encryption': 'AES暗号化',
  'security.diagram.xor.operation': 'XOR演算',
  'security.diagram.iv': '初期化ベクトル',
  'security.features.chunk.title': 'スマートチャンク復号化技術',
  'security.features.chunk.what': 'スマートチャンク復号化とは？',
  'security.features.chunk.description': 'スマートチャンク復号化は、大容量ファイルのために最適化された技術で、ファイルを複数のブロックに分割して並列処理を行い、以下の特徴があります：',
  'security.features.chunk.feature1.title': '動的分割',
  'security.features.chunk.feature1.desc': 'ファイルサイズとシステムメモリに基づいてブロックサイズを自動調整',
  'security.features.chunk.feature2.title': '並列処理',
  'security.features.chunk.feature2.desc': '複数のデータブロックを同時に復号化し、マルチコアCPUを最大限活用',
  'security.features.chunk.feature3.title': 'メモリ最適化',
  'security.features.chunk.feature3.desc': 'ストリーミング処理によりメモリ使用を制御し、オーバーフローを防止',
  'security.features.chunk.feature4.title': '再開サポート',
  'security.features.chunk.feature4.desc': '中断後の継続をサポートし、耐障害性を向上',
  'security.features.chunk.how': '動作の仕組み',
  'security.features.chunk.process': 'スマートチャンク復号化プロセスには以下のステップが含まれます：',
  'security.features.chunk.step1': 'ファイル分析：最適なブロックサイズと数を計算',
  'security.features.chunk.step2': 'データ分割：暗号化ファイルを同サイズのブロックに分割',
  'security.features.chunk.step3': '並列復号化：複数のブロックを同時に復号化',
  'security.features.chunk.step4': 'ストリーム書き込み：復号化されたブロックを順次書き込み',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'パフォーマンスの利点',
  'security.features.chunk.performance.intro': '従来の復号化と比較して、スマートチャンク復号化には以下の大きな利点があります：',
  'security.features.chunk.performance.point1': 'メモリ使用量を最大90%削減、4GBファイルに400MBのみ必要',
  'security.features.chunk.performance.point2': 'マルチコアCPUを活用し、3-5倍高速な復号化速度',
  'security.features.chunk.performance.point3': '大容量ファイル(>4GB)の復号化をサポート、ブラウザメモリ制限なし',
  'security.features.chunk.performance.point4': '正確な進捗と残り時間を表示する視覚的な復号化プロセス',
  'security.features.chunk.usage': '使用例',
  'security.features.chunk.usage.intro': 'スマートチャンク復号化は以下のシナリオに特に適しています：',
  'security.features.chunk.usage.point1': '大容量ファイルの復号化（例：動画、データベースバックアップ）',
  'security.features.chunk.usage.point2': 'メモリ制限のあるデバイスでの復号化操作',
  'security.features.chunk.usage.point3': '並列処理が必要な一括復号化',
  'security.features.chunk.usage.point4': 'リアルタイムフィードバックが必要な復号化タスク',
  'security.features.chunk.diagram': 'スマートチャンク復号化プロセス図',
  'security.features.aes.security': 'セキュリティ特性',
  'security.features.aes.security.intro': 'AES-256-CBCは以下の複数のセキュリティ保証を提供します：',
  'security.features.aes.security.point1': '256ビットキーは2^256の組み合わせを提供し、スーパーコンピュータでも総当たり攻撃は不可能',
  'security.features.aes.security.point2': 'CBCモードにより、同一の平文ブロックが異なる暗号文ブロックを生成し、暗号化のランダム性を向上',
  'security.features.aes.security.point3': '初期化ベクトル（IV）の使用により、同じキーを使用しても毎回異なる暗号化結果を保証',
  'security.features.aes.security.point4': '軍事、金融、その他の高度なセキュリティが要求される分野で広く使用',
  'security.features.aes.diagram': 'CBCモード暗号化プロセスの動的図解',
  'security.features.aes.why': 'なぜAES-256-CBCを選択したのか？',
  'security.features.aes.why.intro': '以下の理由でAES-256-CBCを暗号化標準として選択しました：',
  'security.features.aes.why.point1': '広く検証されたセキュリティ、現在まで実用的な攻撃手法なし',
  'security.features.aes.why.point2': '優れたパフォーマンス、高速な暗号化と復号化',
  'security.features.aes.why.point3': 'ハードウェアアクセラレーション対応、現代のプロセッサにAES命令セットを内蔵',
  'security.features.aes.why.point4': '広範なツールサポート、すべてのプログラミング言語で成熟した実装',
  'security.features.aes.what': 'AES-256-CBCとは？',
  'security.features.aes.description': 'AES-256-CBCは高度暗号化標準（Advanced Encryption Standard）の実装の一つで、以下の特徴があります：',
  'security.features.aes.detail.1': '2001年に米国国立標準技術研究所（NIST）によって制定された対称暗号化アルゴリズム',
  'security.features.aes.detail.2': '256ビットの鍵長を使用し、最高レベルのセキュリティを提供',
  'security.features.aes.detail.3': '暗号ブロック連鎖（Cipher Block Chaining）モードによる、より強力な暗号化セキュリティ',
  'security.features.aes.how': '動作の仕組み',
  'security.features.aes.process': 'AES-256-CBC暗号化プロセスには以下のステップが含まれます：',
  'security.features.aes.step1': '平文データを固定サイズのブロック（128ビット）に分割',
  'security.features.aes.step2': 'ランダムな初期化ベクトル（IV）を生成',
  'security.features.aes.step3': 'CBCモードを使用して前の暗号文ブロックと現在の平文ブロックをXOR演算',
  'security.features.aes.step4': '256ビット鍵を使用してXOR結果にAES暗号化を実行',
  'security.features.aes.example': '暗号化プロセスの例：',
  'decrypt.fileList.column.name': 'ファイル名',
  'decrypt.fileList.column.status': 'ステータス',
  'decrypt.fileList.column.actions': '操作',
  'decrypt.fileList.status.pending': '待機中',
  'decrypt.fileList.status.decrypting': '復号化中',
  'decrypt.fileList.status.success': '完了',
  'decrypt.fileList.status.error': 'エラー',
  'decrypt.fileList.action.info': '情報',
  'decrypt.fileList.empty': 'ファイルがありません。復号化するファイルを追加してください',
  'common.unknown': '不明',
  'common.speed': '速度',
  'common.timeSpent': '経過時間',
  'common.remaining': '残り時間',
  'decrypt.upload.dragText': 'クリックまたはドラッグでファイルを追加',
  'decrypt.upload.hint': '.encryptedファイルの一括追加に対応、ファイルあたり最大 {maxSize}',
  'decrypt.upload.button.decrypt': '選択したファイルを復号化',
  'decrypt.upload.button.clear': 'リストをクリア',
  'page.decrypt.title': 'MyStorage ファイル復号化ツール',
  'page.decrypt.subtitle': '安全にファイルを復号化',
  'page.decrypt.helmet.title': 'ファイル復号化ツール - MyStorage',
  'page.decrypt.helmet.description': '安全なファイル復号化ツール - ブラウザでローカルに復号化してプライバシーを保護',
  'decrypt.fileInfo.modal.title': 'ファイル情報',
  'decrypt.fileInfo.modal.close': '閉じる',
  'decrypt.fileInfo.name': 'ファイル名',
  'decrypt.fileInfo.size': 'ファイルサイズ',
  'decrypt.fileInfo.type': 'ファイルタイプ',
  'decrypt.fileInfo.lastModified': '最終更新日時',
  'decrypt.fileInfo.status': 'ステータス',
  'decrypt.fileInfo.progress': '進捗',
  'decrypt.fileInfo.speed': '速度',
  'decrypt.fileInfo.timeRemaining': '残り時間',
  'decrypt.fileInfo.timeSpent': '経過時間',
  'decrypt.fileInfo.error': 'エラーメッセージ',
  'decrypt.password.modal.title': '復号化パスワードを入力',
  'decrypt.password.modal.placeholder': 'パスワードを入力',
  'decrypt.password.modal.hint': '暗号化時に設定したパスワードを入力してください。パスワードはローカルでの復号化にのみ使用されます',
  'decrypt.message.invalidFile': '.encryptedファイルのみ選択可能です',
  'decrypt.message.duplicate': 'ファイル "{filename}" は既に存在します。自動的に重複を除去しました',
  'decrypt.message.oversizeTitle': 'ファイルサイズ制限超過',
  'decrypt.message.oversizeContent': '以下のファイルが無料ユーザーの制限(4GB)を超えています：',
  'decrypt.message.oversizeHint': 'VIPにアップグレードで容量無制限に',
  'decrypt.message.selectFile': '復号化するファイルを選択してください',
  'decrypt.message.enterPassword': '復号化パスワードを入力してください',
  'decrypt.message.decryptSuccess': 'ファイル {filename} を保存しました',
  'decrypt.message.saveCancel': 'ファイル {filename} の保存をキャンセルしました',
  'decrypt.message.downloadSuccess': 'ファイル {filename} をダウンロードフォルダに保存しました',
  'decrypt.message.decryptError': 'ファイル {filename} の復号化に失敗: {error}',
  'decrypt.message.batchError': '一括復号化に失敗しました。もう一度お試しください',
  'modal.newFolder.title': '新規フォルダ',
  'modal.newFolder.placeholder': 'フォルダ名を入力',
  'modal.newFolder.ok': '作成',
  'modal.newFolder.cancel': 'キャンセル',
  'filelist.modal.rename.title': '名前変更',
  'filelist.modal.rename.placeholder': '新しい名前を入力',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'キャンセル',
  'sideMenu.storageInfo.title': 'ストレージ容量',
  'sideMenu.storageInfo.usage': '使用中 {used} / 合計 {total}',
  'sideMenu.storageStats.title': 'ストレージ統計',
  'sideMenu.storageStats.overview': '概要',
  'sideMenu.storageStats.totalFiles': '総ファイル数',
  'sideMenu.storageStats.totalSize': '総容量',
  'sideMenu.storageStats.fileTypes': 'ファイルタイプ分布',
  'sideMenu.storageStats.providers': 'サービスプロバイダー',
  'common.default': 'デフォルト',
  'common.regionCode': 'リージョンコード',
  'common.nodeType': 'ノードタイプ',
  'common.storageUsed': '使用済み容量',
  'common.storageAvailable': '利用可能容量',
  'common.storageLimit': '総容量',
  'common.storageUsageDetail': '使用中 {used} / 合計 {total}',
  'common.defaultNode': 'デフォルトノード',
  'common.confirm': '確認',
  'common.cancel': 'キャンセル',
  'common.latency': 'レイテンシ',
  'common.retry': '再試行',
  'cloudDrive.nodeSelect.title': 'ストレージノードを選択',
  'cloudDrive.nodeSelect.addNode': 'ストレージノードを追加',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'ノード削除の確認',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'ノード「{nodeName}」を削除してもよろしいですか？この操作は元に戻せません！',
  'cloudDrive.nodeSelect.deleteSuccess': 'ノードが正常に削除されました',
  'cloudDrive.nodeSelect.deleteFailed': 'ノードの削除に失敗しました',
  
  // ノード作成
  'cloudDrive.nodeCreate.title': 'ストレージノードを追加',
  'cloudDrive.nodeCreate.selectProvider': 'クラウドプロバイダーを選択',
  'cloudDrive.nodeCreate.nodeName': 'ノード名',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': '空欄の場合はデフォルト名を使用します',
  'cloudDrive.nodeCreate.nameMaxLength': 'ノード名は50文字を超えることはできません',
  'cloudDrive.nodeCreate.noProviders': '利用可能なクラウドプロバイダーがありません',
  'cloudDrive.nodeCreate.pingLatency': 'レイテンシ {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'レイテンシをテスト中...',
  'cloudDrive.nodeCreate.pingFailed': 'レイテンシテストに失敗しました',
  'cloudDrive.nodeCreate.pingUnavailable': 'レイテンシテストは利用できません',
  'cloudDrive.nodeCreate.sortByLatency': 'レイテンシで並び替え',
  'cloudDrive.nodeCreate.selectRegion': 'リージョンを選択',
  'cloudDrive.nodeCreate.selectedRegion': '選択されたリージョン',
  'cloudDrive.nodeCreate.noRegions': '利用可能なリージョンがありません',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'クラウドプロバイダーを選択してください',
  'cloudDrive.nodeCreate.selectProviderRequired': 'まずクラウドプロバイダーを選択してください',
  'cloudDrive.nodeCreate.selectRegionRequired': 'まずリージョンを選択してください',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'クラウドプロバイダーリストの読み込みに失敗しました',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'リージョンリストの読み込みに失敗しました',
  'cloudDrive.nodeCreate.nodeType': 'ノードタイプ',
  'cloudDrive.nodeCreate.nodeType.standard': '標準ストレージ',
  'cloudDrive.nodeCreate.nodeType.lowFreq': '低頻度ストレージ',
  'cloudDrive.nodeCreate.nodeType.archive': 'アーカイブストレージ',
  'cloudDrive.nodeCreate.storageLimit': 'ストレージ制限',
  'cloudDrive.nodeCreate.storageLimitRequired': 'ストレージ制限を入力してください',
  'cloudDrive.nodeCreate.storageLimitMin': 'ストレージ制限は1GB未満にできません',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'ストレージ制限を入力してください（GB）',
  'cloudDrive.nodeCreate.success': 'ストレージノードが正常に作成されました',
  'cloudDrive.nodeCreate.failed': 'ストレージノードの作成に失敗しました',
  
  // ノード編集
  'cloudDrive.nodeEdit.title': 'ノードを編集',
  'cloudDrive.nodeEdit.name': 'ノード名',
  'cloudDrive.nodeEdit.nameRequired': 'ノード名を入力してください',
  'cloudDrive.nodeEdit.nameMaxLength': 'ノード名は50文字を超えることはできません'
}; 